import ContactImportModal from '@agtech/web-imports/integrations/ContactImportModal'
import { AgTechButtonProps, AgTechButton } from '@agtech/web/components/Buttons/AgTechButtons'
import { AgTechFormSection } from '@agtech/web/components/Forms/Layout/AgTechFormSection'
import AgTechActionPane from '@agtech/web/components/Headers/AgTechActionPane'
import { AgTechPopUpPosition } from '@agtech/web/components/Portals/Popups/Helpers/AgTechPopUpData'
import ContactDialog from '@agtech/web/integrations/contacts/dialogs/ContactDialog'
import React from 'react'
import BidderRegistrationDialog from '../../../bidders/dialogs/BidderRegistrationDialog'
import BidderSelectionViewDialog from '../../../bidders/dialogs/BidderSelectionViewDialog'
import LotDialog from '../../../lots/dialogs/LotDialog'
import SaleContactMasterDetailDialog from '../../../contacts/dialogs/master/SaleContactMasterDetailDialog'
import LotManagementDialog from '../../../lots/dialogs/LotManagementDialog'
import LotSaleOrderUpdateDialog from '../../../lots/dialogs/LotSaleOrderUpdateDialog'
import LotCategoryDialog from '../../../lotCategories/dialogs/LotCategoryDialog'
import SaleLotImportModal from '../../../lots/modals/SaleLotImportModal'
import LotSellingViewDialog from '../../../lots/dialogs/LotSellingViewDialog'
import LotUpdateViewDialog from '../../../lots/dialogs/LotUpdateViewDialog'

export const SaleQuickActionsPopUp = () => {
    return (
        <div className='rounded px-3 pt-1 pb-6 gap-y-2 stretched row-based flex' style={{ width: 600 }}>
            <div id='sale-quick-actions-lots'>
                <AgTechFormSection header='Lots' bodyClasses='wide gap-y-6 flex'>
                    <AgTechActionPane
                        elements={[
                            <LotManagementDialog.Button text='Manage My Lots' classes='button-link' />,
                            <LotDialog.Button text='Create New Lot' classes='button-link' />,
                            <SaleLotImportModal.Button text='Import Lots' classes='button-link' />
                        ]}
                        customization={{
                            elementClasses: 'flexed centered',
                            width: 150,
                        }}
                    />
                    <AgTechActionPane
                        elements={[
                            <LotSaleOrderUpdateDialog.Button classes='button-link' />,
                            <LotSellingViewDialog.Button classes='button-link' />,
                            <LotUpdateViewDialog.Button classes='button-link' />
                        ]}
                        customization={{
                            elementClasses: 'flexed centered',
                            minElements: 3,
                            width: 150,
                        }}
                    />
                    <AgTechActionPane
                        elements={[
                            <LotCategoryDialog.Button text='New Lot Category' classes='button-link' />,
                            <></>,
                            <></>
                        ]}
                    />
                </AgTechFormSection>
            </div>
            <div id='sale-quick-actions-bidders'>
                <AgTechFormSection header='Bidders' bodyClasses='wide container'>
                    <AgTechActionPane
                        elements={[
                            <BidderSelectionViewDialog.Button text='View Bidders' classes='button-link' />,
                            <BidderRegistrationDialog.Button text='Register Bidder' classes='button-link' />,
                        ]}
                        customization={{
                            elementClasses: 'flexed centered',
                            width: 150,
                            minElements: 3
                        }}
                    />
                </AgTechFormSection>
            </div>
            <div id='sale-quick-actions-contacts'>
                <AgTechFormSection header='Contacts' bodyClasses='wide container'>
                    <AgTechActionPane
                        elements={[
                            <SaleContactMasterDetailDialog.Button text='View Contacts' classes='button-link' />,
                            <ContactDialog.Button classes='button-link' />,
                            <ContactImportModal.Button classes='button-link' />
                        ]}
                        customization={{
                            elementClasses: 'flexed centered',
                            width: 150,
                            minElements: 3
                        }}
                    />
                </AgTechFormSection>
            </div>
            {/* <AgTechFormSection header='Sales' bodyClasses='wide pb-2 container'>
                <AgTechActionPane
                    elements={[
                        <SaleDialog.Button classes='link' />,
                    ]}
                    customization={{
                        elementClasses: 'centered',
                        width: 150,
                        minElements: 3
                    }}
                />
            </AgTechFormSection> */}
        </div>
    )
}

export const SaleQuickActionsButton = (props: AgTechButtonProps) => {
    return (
        <AgTechButton
            text='Quick Actions'
            icon='bi bi-lightning-fill'
            {...props}
            action={e => e.popups.showPopUp({
                popup: () => <SaleQuickActionsPopUp />,
                callerRef: e.clickableRef,
                config: {
                    position: AgTechPopUpPosition.BelowRight,
                    shouldCloseOnBlur: false
                }
            })}
        />
    )
}